import { FC } from 'react';
import { EasyField } from 'react-bootstrap-formutil';
import { CustomerInfoKeyType, HomeAddressTypeEnum } from 'types/customer';
import classlist from 'utils/classlist';
import BaseAddress, { BaseAddressProps } from './BaseAddress';

export interface CommonHomeAddressProps extends Omit<BaseAddressProps, 'prefix'> {
    hasCountry?: boolean;
    legalResidenceCountry?: string;
}

export const getCommonHomeAddressFields = (needHomeAddressType: boolean = true) => {
    const baseFields: CustomerInfoKeyType[] = [
        'home_state',
        'home_city',
        'home_detail',
        'home_postal',
        'same_delivery_and_residence'
    ];

    return needHomeAddressType ? baseFields.concat('home_address_type') : baseFields;
};

const CommonHomeAddress: FC<CommonHomeAddressProps> = ({
    className,
    hasCountry,
    legalResidenceCountry,
    ...restProps
}) => {
    return (
        <div className={classlist('common-home-address-root', className)}>
            <BaseAddress prefix="home" {...restProps} />
            {hasCountry && <EasyField type="hidden" name="home_country" $defaultValue={legalResidenceCountry} />}
            <EasyField name="home_address_type" type="hidden" $defaultValue={HomeAddressTypeEnum.COMMON} />
        </div>
    );
};

export default CommonHomeAddress;
